/**
 * @generated SignedSource<<e81319202ba59a5440237b00f5c6ba44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_viewer">;
  readonly " $fragmentType": "PdpRespDetailTabs_viewer";
};
export type PdpRespDetailTabs_viewer$key = {
  readonly " $data"?: PdpRespDetailTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "89b00ef269eadacf16463602e785b590";

export default node;
